export default {"src":"/_next/static/media/rotation.851fc8c0.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};